import React from "react";

type ForEachContainerProps = {
  children: React.ReactNode;
  linkedAnswer: string;
};

const ForEachContainer = ({
  children,
  linkedAnswer,
}: ForEachContainerProps) => {
  return (
    <div className="bg-gray-100 mx-0 sm:mx-2 rounded-md mb-2 py-1.5 sm:py-2">
      <div
        className="text-center font-semibold italic px-2"
        style={{
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}
      >
        {linkedAnswer}
      </div>
      <div className="space-y-4">{children}</div>
    </div>
  );
};

export default ForEachContainer;
